import { parseNumber, parseString, transformModel } from '~/src/dash/api/resource-transforms';
import { addDomainAndTokenToUrl, IHttpResponse, restGet } from '~/src/dash/api/rest';

export interface IEPGChannelMapPair {
  ID: number;
  CreatedAt?: string;
  UpdatedAt?: string;
  DeletedAt?: string;

  EPGChannelID: string;
  PublicaChannelID: number;
  PublicaChannelName: string;
  ContentChannel: string;
}

export const transformEPGChannelMapPair = transformModel<IEPGChannelMapPair>({
  ID: parseNumber(['ID']),
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  DeletedAt: 'DeletedAt',

  EPGChannelID: parseString(['EPGChannelID']),
  PublicaChannelID: parseNumber(['PublicaChannelID']),
  PublicaChannelName: parseString(['PublicaChannelName']),
  ContentChannel: parseString(['ContentChannel']),
});

// GET all EPGChannels for this publisher
// /publishers/{publisherID}/epg_channel_map_pairs
export async function getEPGChannelMapPairs(publisherID: string): Promise<IEPGChannelMapPair[]> {
  const reqUrl = addDomainAndTokenToUrl(`/publishers/${publisherID}/epg_channel_map_pairs`);
  return await restGet<IEPGChannelMapPair[]>(reqUrl, {}).then(
    (val: IHttpResponse<IEPGChannelMapPair[]>) => {
      return val.parsedBody ? val.parsedBody.map(transformEPGChannelMapPair) : [];
    },
  );
}
